export default __webpack_public_path__ + "static/media/ChromeDev.cf97f625.png";